import { Banner, BlockStack, Modal, } from '@shopify/polaris';
import { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import './index.scss';
//翻译包
import Language from '../../i18n/Language';
import { reqGetGuideCoupon } from '../../api';
const t = Language;

const CongratsModal = (props) => {
    const {
        congraState,
        toggleToast,
        updCongraState,

    } = props;

    const [active, setActive] = useState(false);
    const [bannerTip, setBannerTip] = useState("");
    const [couponLoading, setCouponLoading] = useState(false);

    // 状态改变
    const handleCloseChange = () => {
        updCongraState(0);
        setBannerTip("");
    }

    // 跳转
    const handleJumpPricing = async () => {
        // 获取折扣
        setCouponLoading(true);
        const res = await reqGetGuideCoupon();
        if (res.ack === 1) {
            updCongraState(1);
            setBannerTip("");
            // utils.routeJump(this, "/plan");
            // shopify 内嵌模式
            const isShopify = window.shopify;
            const url = '/plan';
            if (isShopify && window.opener) {
                handleModalToMain(url, null, null);
            } else {
                let paths = {
                    pathname: url,
                    query: null,
                }
                props.history.push(paths);
            }

        } else {
            // toggleToast(t("Try again later"), true);
            setBannerTip(res.msg);
        }
        if (res) {
            setCouponLoading(false);
        }
    }

    // 判断是否内嵌及退出全屏
    const handleModalToMain = (url, _state = null, _query = null) => {
        sendDataToMain({ url, objs: "OnpageAI_Modal", _state, _query });
    }

    // 传递参数到主窗口 关闭窗口+跳转
    const sendDataToMain = (info = "") => {
        const _winOpr = window.opener;
        if (_winOpr) {
            let { url, objs, _state, _query } = info;
            _winOpr.postMessage({ mode: "UpgradeOpener", url, objs, _state, _query }, window.location.origin);    // 传递数据到主窗口
        }
    }

    //点击联系客服
    const handleContactService = () => {
        try {
            window.Willdesk.show()
        } catch (e) {
            toggleToast(t("Try again later"), true);
        }
    }

    // 完成icon
    const checkIcon = <svg viewBox="0 0 20 20" className="Icon_Icon__uZZKy" width={20} height={20}><path fillRule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"></path></svg>

    useEffect(() => {
        setActive(congraState === -1 ? false : congraState);
    }, [congraState])

    return <Modal
        open={active}
        onClose={handleCloseChange}
        title={"🎉 " + t("Congrats! You’re All Set + 40% OFF Unlocked!")}
        primaryAction={{
            content: "🚀 " + t("Claim My Discount") + " →",
            loading: couponLoading,
            onAction: handleJumpPricing,
        }}
    >
        <Modal.Section>
            <BlockStack gap={200}>
                {
                    bannerTip && <Banner
                        title={t(bannerTip)}
                        tone='critical'
                        action={{
                            content: t("Contact us"),
                            onAction: handleContactService
                        }}
                        onDismiss={() => {
                            setBannerTip("");
                        }}
                    ></Banner>
                }
                <div className='congrats_info'>
                    <p>{t("Smart move! Upgrade to premium and save big")}:</p>
                    <span>{checkIcon} {t("Full SEO tools access")}</span>
                    <span>{checkIcon} {t("Priority support")}</span>
                    <span>{checkIcon} {t("Cancel anytime")}</span>
                </div>
            </BlockStack>
        </Modal.Section>
    </Modal>
}

export default withRouter(CongratsModal);